import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import HomePage from './modules/main';
import BolosPage from './modules/main/components/galery/bolos';
import ContatoPage from './modules/main/components/contato';
import DocesPage from './modules/main/components/galery/doces';
import TortasPage from './modules/main/components/galery/tortas';
import DiversosPage from './modules/main/components/galery/diversos';
import QuemSomoPage from './modules/main/components/quemsomos';

const Routes = () => (
    <Router>
        <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/bolos" component={BolosPage} />
            <Route path="/contato" component={ContatoPage} />
            <Route path="/doces" component={DocesPage} />
            <Route path="/tortas" component={TortasPage} />
            <Route path="/diversos" component={DiversosPage} />
            <Route path="/quemsomos" component={QuemSomoPage} />
            <Route path="*"/>
        </Switch>
    </Router>
);

export default Routes;